
import React from 'react';

/* plugins */
import { BrowserRouter } from "react-router-dom";

/* routes */
import AppRoutes from './routes';
function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;